import { useState, useEffect } from "react";
import _ from "lodash/fp";

function createImageFromDivBackground(divElement) {
  const backgroundImage = window.getComputedStyle(divElement).backgroundImage;

  // Verifica se existe uma imagem de fundo
  if (!backgroundImage || backgroundImage === 'none') {
    return [];
  }

  // Extrai a URL da imagem (remove `url("...")` ou `url('...')`)
  const urlMatch = backgroundImage.match(/url\(["']?(.*?)["']?\)/);
  if (!urlMatch || !urlMatch[1]) {
    return [];
  }

  const imageUrl = urlMatch[1];
  const img = new Image();
  img.src = imageUrl;

  return img;
}

export const useOnLoadImages = (ref) => {
  const [status, setStatus] = useState(false);

  useEffect(() => {
    const updateStatus = (images) => {
      setStatus(
        images.map((image) => image.complete).every((item) => item === true)
      );
    };

    if (!ref?.current) return;

    const imagesLoaded = _.flatMap(el =>
        el.classList.contains("wait-background-image")
          ? createImageFromDivBackground(el)
          : [el],
      Array.from(ref.current.querySelectorAll("img,.wait-background-image"))
    )
    
    if (imagesLoaded.length === 0) {
      setStatus(true);
      return;
    }

    imagesLoaded.forEach((image) => {
      image.addEventListener("load", () => updateStatus(imagesLoaded), {
        once: true
      });
      image.addEventListener("error", () => updateStatus(imagesLoaded), {
        once: true
      });
    });
    updateStatus(imagesLoaded)
    return;
  }, [ref]);

  return status;
};